const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMarkWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 66.364 L 45 66.364 c -2.979 0 -5.429 -2.345 -5.56 -5.321 l -5.132 -49.519 C 33.841 5.304 38.762 0 45 0 h 0 c 6.238 0 11.159 5.304 10.692 11.524 L 50.56 61.043 C 50.429 64.019 47.979 66.364 45 66.364 z",
    style: {
      fill: "rgb(255,255,255)"
    },
    transform: "matrix(1 0 0 1 0 0)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.998,
    cy: 81.128,
    r: 8.868,
    style: {
      fill: "rgb(255,255,255)"
    },
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 0 c -1.045 0 -2.048 0.161 -3 0.438 c 4.73 1.377 8.08 5.908 7.692 11.086 L 44.56 61.043 c -0.082 1.873 -1.086 3.494 -2.56 4.44 c 0.867 0.557 1.897 0.881 3 0.881 c 2.979 0 5.429 -2.345 5.56 -5.321 l 5.132 -49.519 C 56.159 5.304 51.238 0 45 0 z",
    style: {
      fill: "rgb(255,255,255)"
    },
    transform: "matrix(1 0 0 1 0 0)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 72.264 c -1.055 0 -2.062 0.194 -3 0.531 c 3.419 1.231 5.868 4.493 5.868 8.336 S 45.419 88.237 42 89.469 C 42.938 89.806 43.945 90 45 90 c 4.898 0 8.868 -3.97 8.868 -8.868 C 53.868 76.234 49.898 72.264 45 72.264 z",
    style: {
      fill: "rgb(255,255,255)"
    },
    transform: "matrix(1 0 0 1 0 0)",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkWhite);
export default __webpack_public_path__ + "static/media/exclamation-mark-white.a17e654f9c317fa2c157ffb780a4e1fe.svg";
export { ForwardRef as ReactComponent };